<div class="pt-8">
  @if (text.length > 0) {
    <p class="small mb-4">
      <em>{{ text }}</em>
    </p>
  }
  @if (items && items.length > 0) {
    <ul class="small list-inside list-disc">
      @for (item of items; track item) {
        <li>
          {{ item }}
        </li>
      }
    </ul>
  }
</div>
